exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#pages>.v-content__wrap>.v-image{padding-top:64px;padding-bottom:88px}#pages .v-responsive__sizer{display:none}#pages .v-image--md{padding:188px 0}#pages .v-image--sm{padding:96px 0 188px 0}", ""]);

// exports
